/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './nav.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/router';
import * as i3 from '@angular/common';
import * as i4 from '../../../../app/core/nav/nav.component';
const styles_NavComponent:any[] = [i0.styles];
export const RenderType_NavComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,styles:styles_NavComponent,
    data:{}});
export function View_NavComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),25,'nav',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(2,0,(null as any),(null as any),
      22,'div',[['class','container']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵeld(4,
      0,(null as any),(null as any),19,'div',[['class','nav-wrapper']],(null as any),
      (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
      (null as any),['\n            '])),(_l()(),i1.ɵeld(6,0,(null as any),(null as any),
      2,'a',[['class','brand-logo'],['routerLink','']],[[1,'target',0],[8,'href',4]],
      [[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,7).onClick($event.button,$event.ctrlKey,
              $event.metaKey,$event.shiftKey)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(7,671744,(null as any),0,i2.RouterLinkWithHref,
      [i2.Router,i2.ActivatedRoute,i3.LocationStrategy],{routerLink:[0,'routerLink']},
      (null as any)),(_l()(),i1.ɵted(-1,(null as any),['Front Page Stats'])),(_l()(),
      i1.ɵted(-1,(null as any),['\n            '])),(_l()(),i1.ɵeld(10,0,(null as any),
      (null as any),12,'ul',[['class','right hide-on-med-and-down'],['id','nav']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(-1,(null as any),['\n                '])),(_l()(),i1.ɵeld(12,0,(null as any),
      (null as any),3,'li',([] as any[]),(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵeld(13,0,(null as any),(null as any),
      2,'a',[['routerLink','']],[[1,'target',0],[8,'href',4]],[[(null as any),'click']],
      (_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,14).onClick($event.button,$event.ctrlKey,
              $event.metaKey,$event.shiftKey)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(14,671744,(null as any),0,i2.RouterLinkWithHref,
      [i2.Router,i2.ActivatedRoute,i3.LocationStrategy],{routerLink:[0,'routerLink']},
      (null as any)),(_l()(),i1.ɵted(-1,(null as any),['Home'])),(_l()(),i1.ɵted(-1,
      (null as any),['\n                '])),(_l()(),i1.ɵted(-1,(null as any),['\n                '])),
      (_l()(),i1.ɵeld(18,0,(null as any),(null as any),3,'li',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵeld(19,
          0,(null as any),(null as any),2,'a',[['routerLink','donate']],[[1,'target',
              0],[8,'href',4]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,20).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(20,671744,(null as any),0,i2.RouterLinkWithHref,
          [i2.Router,i2.ActivatedRoute,i3.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['Donate'])),(_l()(),i1.ɵted(-1,
          (null as any),['\n            '])),(_l()(),i1.ɵted(-1,(null as any),['\n\n        '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    const currVal_2:any = '';
    _ck(_v,7,0,currVal_2);
    const currVal_5:any = '';
    _ck(_v,14,0,currVal_5);
    const currVal_8:any = 'donate';
    _ck(_v,20,0,currVal_8);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,7).target;
    const currVal_1:any = i1.ɵnov(_v,7).href;
    _ck(_v,6,0,currVal_0,currVal_1);
    const currVal_3:any = i1.ɵnov(_v,14).target;
    const currVal_4:any = i1.ɵnov(_v,14).href;
    _ck(_v,13,0,currVal_3,currVal_4);
    const currVal_6:any = i1.ɵnov(_v,20).target;
    const currVal_7:any = i1.ɵnov(_v,20).href;
    _ck(_v,19,0,currVal_6,currVal_7);
  });
}
export function View_NavComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-nav',([] as any[]),
      (null as any),(null as any),(null as any),View_NavComponent_0,RenderType_NavComponent)),
      i1.ɵdid(1,114688,(null as any),0,i4.NavComponent,([] as any[]),(null as any),
          (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const NavComponentNgFactory:i1.ComponentFactory<i4.NavComponent> = i1.ɵccf('app-nav',
    i4.NavComponent,View_NavComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /codebuild/output/src946329470/src/frontend/src/$$_gendir/app/core/nav/nav.component.ngfactory.ts